/*global chrome*/
import { HashRouter,Route,Routes,BrowserRouter as Router } from 'react-router-dom';
import LayOut from './LayOut';
import VoiceToText from './VoiceToText';
import ReceivedText from './ReceivedText';
import CreateRoom from './CreateRoom';
import Registration from './AuthPages/Registration';
import Login from './AuthPages/Login';
import { useEffect, useState } from 'react';
import Summarize from './Summarizer/Summarize';
import WrapUp from './WrapUp';
import TabConfig from './Pages/Services/TabConfig';
import WelcomeScreen from './WelcomeScreen';




const App = () => {
  

  return (
   <>
   {/* <HashRouter> */}
   <Router>

   <Routes>
    <Route path='/' element={<LayOut/>}>
    {/* <Route index element={<WelcomeScreen/>} /> */}
    <Route index element={<CreateRoom/>}/>
    <Route path='VoiceToText' element={<VoiceToText/>}/>
    <Route path='ReceivedText' element={<ReceivedText/>}/>
    <Route path='Login' element={<Login/>}/>
    <Route path='Registration' element={<Registration/>}/>
    <Route path='summarize' element={<Summarize/>} />
    <Route path='wrap-up' element={<WrapUp/>}/>
    </Route>
    <Route path='config' element={<TabConfig/>}/>
   </Routes>
   </Router>
   {/* </HashRouter> */}

   </>
  );
};

export default App;
